module.exports = "../images/cabin-4-person-3@2x.jpg?v=d586eaa";